import { type Meta } from '../types/docs';
import { UPLOAD_ANALYTICS_COMMON_META_PARAMS } from './uploadAnalyticsMetaParams';

const META: Meta = {
  description: 'Upload failed',
  name: 'upload_error',
  params: [
    ...UPLOAD_ANALYTICS_COMMON_META_PARAMS,
    {
      description: 'Time from queue creation to failure in milliseconds',
      name: 'upload_duration_ms',
      required: false,
      type: 'number',
    },
    {
      description: 'Failure message',
      name: 'error_message',
      required: true,
      type: 'string',
    },
    {
      description: 'JavaScript error name',
      name: 'error_name',
      required: false,
      type: 'string',
    },
    {
      description: 'HTTP status code for upload status errors',
      name: 'error_status_code',
      required: false,
      type: 'number',
    },
    {
      description: 'Whether the transfer error is retryable',
      name: 'is_retryable',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Upload lifecycle stage that failed',
      name: 'failed_stage',
      required: true,
      type: 'enum',
      values: ['create_upload', 'small_upload', 'part_upload', 'complete_upload', 'unknown'],
    },
    {
      description: 'Which presigned URL type the upload used before failure; multipart uploads may be mixed',
      name: 'upload_url_type',
      required: false,
      type: 'enum',
      values: ['primary', 'fallback', 'mixed'],
    },
  ],
};

export default META;
